import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import DndTypes from './DnDTypes';
import { canDropColumnOnFirst, useOETDragState } from './dndContext';

/**
 * Empty first cell of the OET header. This is a drop target for the column
 * header cells so a column can be moved to the start (`moveColumn(from, 0)`,
 * computed in the container's `onDragEnd`). Dropping the first column here is a
 * no-op.
 */
const OETFirstHeaderCell = () => {
  const { setNodeRef } = useDroppable({
    id: 'oet-col-tgt-first',
    data: { kind: 'column-first' },
  });

  const { activeItem, overId } = useOETDragState();
  const isOver = overId === 'oet-col-tgt-first';
  const canDrop =
    activeItem != null &&
    activeItem.type === DndTypes.COLUMN &&
    canDropColumnOnFirst(activeItem);

  return <th ref={setNodeRef} className={isOver && canDrop ? 'drop-highlight' : ''} />;
};

export default OETFirstHeaderCell;
